import React, { Component } from 'react';
import { MenuItem } from 'material-ui';
import PropTypes from 'prop-types';

import { locationsMenuConstant } from '../../data/Constants';
import { sendKmlFile } from '../../api/ImportTool';
import { checkIsAuthorized } from '../../utils/AuthorizationChecks';

class AdditionalLocationMenuItems extends Component {
  constructor(props) {
    super(props);
    this.state = { image: props.image };
    this.deliveryKml = React.createRef();
    this.cateringKml = React.createRef();
  }

  onClickDeliveryZones = () => {
    const { rowData, history } = this.props;
    const { LOCATIONS, ZONES } = locationsMenuConstant;
    const { id } = rowData
    history.push(`/${LOCATIONS}/${id}/${ZONES}/`);
  }

  onClickCateringZones = () => {
    const { rowData, history } = this.props;
    const { LOCATIONS, CATERING_ZONES } = locationsMenuConstant;
    const { id } = rowData
    history.push(`/${LOCATIONS}/${id}/${CATERING_ZONES}/`);
  }

  handleKmlFileUpload({isCateringKML, event}) {
    const { apiToken, rowData, handleMenuClose } = this.props;
    const { id } = rowData
    const {
      LOCATIONS,
      CATERING_ZONES,
      CONFIRM_UPLOAD_DELIVERY_KML,
      CONFIRM_UPLOAD_CATERING_KML,
      KML,
    } = locationsMenuConstant;

    event.stopPropagation();
    event.preventDefault();

    const confirmation = isCateringKML ? CONFIRM_UPLOAD_CATERING_KML : CONFIRM_UPLOAD_DELIVERY_KML;

    const confirmUpload = window.confirm(`${confirmation} ${event.target.files[0].name}?`);
    if (confirmUpload) {
      const file = event.target.files[0];
      const path = isCateringKML ? `${LOCATIONS}/${id}/${CATERING_ZONES}/${KML}` : `${LOCATIONS}/${id}/${KML}`;
      sendKmlFile(apiToken, path, file);
      handleMenuClose();
    }
    event.target.value = null;
  }

  onUploadDeliveryKml = () => {
    this.deliveryKml.current.click();
  }

  onUploadCateringKml = () => {
    this.cateringKml.current.click();
  }

  getAuth = () => {
    const { admin } = this.props;
    const { 
      LOCATIONS,
      ZONES,
      CATERING_ZONES,
      ADD,
      VIEW,
    } = locationsMenuConstant;
    const isAuthToViewDelivery = checkIsAuthorized(admin, LOCATIONS, ZONES, VIEW);
    const isAuthToAddDelivery = checkIsAuthorized(admin, LOCATIONS, ZONES, ADD);
    const isAuthToViewCatering = checkIsAuthorized(admin, LOCATIONS, CATERING_ZONES, VIEW);
    const isAuthToAddCatering = checkIsAuthorized(admin, LOCATIONS, CATERING_ZONES, ADD);
    return { isAuthToViewDelivery, isAuthToAddDelivery, isAuthToViewCatering, isAuthToAddCatering };
  }

  render() {
    const {
      isAuthToViewDelivery,
      isAuthToAddDelivery,
      isAuthToViewCatering,
      isAuthToAddCatering
    } = this.getAuth();

    const { 
      KML_TYPE,
      KML_EXTENSION,
    } = locationsMenuConstant;

    return (
     <div>
      {
        isAuthToViewDelivery && <MenuItem onClick={this.onClickDeliveryZones}>
          Delivery Zones
        </MenuItem>
      }
      { 
        isAuthToViewCatering && <MenuItem onClick={this.onClickCateringZones}>
          Catering Zones
        </MenuItem>
      }
      { 
        isAuthToAddDelivery && <div>
          <MenuItem onClick={this.onUploadDeliveryKml}>
            Upload .kml for Delivery Zone
          </MenuItem>
          <input
            type={KML_TYPE}
            accept={KML_EXTENSION}
            style={{ display: 'none' }}
            ref={this.deliveryKml}
            onChange={(event) => this.handleKmlFileUpload({event, isCateringKML: false})}
          />
        </div>
      }
      {
        isAuthToAddCatering && <div> 
          <MenuItem onClick={this.onUploadCateringKml}>
            Upload .kml for Catering Zone
          </MenuItem>
          <input
            type={KML_TYPE}
            accept={KML_EXTENSION}
            style={{ display: 'none' }}
            ref={this.cateringKml}
            onChange={(event) => this.handleKmlFileUpload({event, isCateringKML: true})}
          />
        </div>
      }
     </div>
    );
  }
}

AdditionalLocationMenuItems.propTypes = {
  admin: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  rowData: PropTypes.objectOf(PropTypes.any),
  handleMenuClose: PropTypes.func.isRequired,
};

AdditionalLocationMenuItems.defaultProps = {
  rowData: {},
};

export default AdditionalLocationMenuItems;
